
const urls = {
  loginUrl: '/auth/login', 
  logoutUrl: '/auth/logout', 
  getMenusUrl: '/home/menus',
  getCurrentUrl: '/home/currentData/info',
  getCurrentMonthUrl: '/home/currentMonthData/info',
  getHomeTotalUrl: '/home/totalData/info',
  getFlowTotalUrl: '/home/flowTotalDataRank/info',
  getAverageUrl: '/home/avgDayData/info',
  getMapDataUrl: '/home/map/info',
  getHaveTimeRankUrl: '/home/haveTimeRank/info',
  getLastFlowUrl: '/home/lastTotalFlowData/info',
  getMapDetailUrl: '/home', 
  getParameterUrl: '/history/groupName', 
  getHistoryDataUrl: '/history/historyData', 
  getWarningUrl: '/warning', 
  getWarningPageUrl: '/warning/page', 
  getWarningDetailUrl: '/warning', 
  getUpdateNoteUrl: '/warning/ursache', 
  getCompanyByUserUrl: '/dataDetail', 
  getGroupUrl: '/dataDetail', 
  getSiteInfoByCompanyUrl: '/dataDetail', 
  getStaticsTimeUrl: '/dataDetail', 
  getFlowDataUrl: '/dataDetail/flowData', 
  getSiteDataUrl: '/dataDetail/siteData',
  getAverageDataUrl: '/flowStatistic/avgDayData', 
  getAverageRankUrl: '/flowStatistic/flowAvgDayDataRank', 
  getTotalDataUrl: '/flowStatistic/totalData', 
  getTimeConfigUrl: '/flowStatistic/timeConfig',
  getTotalRankUrl: '/flowStatistic/flowTotalDataRank',
  getDeviceUrl: '/realmonitor/getSiteDeviceParams',
  getNumUrl: '/siteParamterDistribute/queryAlarmAmount', 
  getIssueUrl: '/siteParamterDistribute/getSiteParamIssue', 
  getSiteInfoUrl: '/siteParamterDistribute/getSiteRTU', 
  getSpotDeviceUrl: '/siteParamterDistribute/getSpotDeviceInfo',
  addIssuedUrl: '/collectParameter/write',
  getAlarmAmountUrl: '/siteParamterDistribute/queryAlarmAmount',
  getHeaderUrl: '/whiteboard/listHead',
  getWhiteUrl: '/whiteboard/listData',
  getManageCompanyUrl: '/siteParamterDistribute/getmanagecompany', 
  getManageLabelUrl: '/siteParamterDistribute/getlable', 
  getManageSiteUrl: '/siteParamterDistribute/getsite', 
}

export default urls